module.exports = __webpack_public_path__ + "static/media/lk-puzzle-templo-gangaramaya.195cc6fc.jpg";